import { useContext, useEffect, useState } from "react";

export const useDifferentDebitorModal = (messages, onCancel) => {

    const [dialogVisible, setDialogVisible] = useState(false)

    const cancelHandler = e => {
        onCancel()
        setDialogVisible(false)       
    }

    const acceptHandler = e => {
        setDialogVisible(false)
    }

    const showDialog = () => {
        setDialogVisible(true)
    } 

    return {dialogVisible, showDialog, cancelHandler, messages, acceptHandler}

}